import React, { Component } from 'react';
import { Container, Row, Col, Form, Image, Button, Dropdown, DropdownButton,FormControl} from 'react-bootstrap';
import ReactNotification from 'react-notifications-component';
import NumberFormat from 'react-number-format';


import NavbarComponent from '../Navbar/index';
import RenovateTokenAlert from '../../RenovateToken';

import './index.css'
import Card from '../../Images/Ejemplo_Tarjeta.png'

import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import icons from '../Landing/icons.json'

import CardView from './Components/CardView'
import Solicitud from './Components/Solicitud'
import Payment from './Components/Payment'
import Confirm from './Components/Confirm'
import StatusView from './Components/Status'

import Connection from '../../Calls'
import Backend from '../../Backend'



export default class SettingIndex extends Component {
  constructor(props){
    super(props)
    this.state = {
      tab:'card',
      StartDate:'',
      EndDate:'',
      transactions:[{type:'expense', amount:'10 usd', concept:"7 ELEVEN 1593 SN PEDRO GARZ MEX", fecha:"Feb 2"},{type:'expense', amount:'10 usd', concept:"7 ELEVEN 1593 SN PEDRO GARZ MEX", fecha:"Feb 2"},
      {type:'expense', amount:'10 usd', concept:"7 ELEVEN 1593 SN PEDRO GARZ MEX", fecha:"Feb 2"},{type:'expense', amount:'10 usd', concept:"7 ELEVEN 1593 SN PEDRO GARZ MEX", fecha:"Feb 2"},
      {type:'expense', amount:'10 usd', concept:"7 ELEVEN 1593 SN PEDRO GARZ MEX", fecha:"Feb 2"},{type:'expense', amount:'10 usd', concept:"7 ELEVEN 1593 SN PEDRO GARZ MEX", fecha:"Feb 2"}],
      statusCard:''

    }
    this.GetStatusCard = this.GetStatusCard.bind(this)
  }

  componentDidMount(){
    var date = new Date();
    this.setState({
        StartDate: new Date(date. getFullYear(), date. getMonth(), 1),
        EndDate:new Date(date. getFullYear(), date. getMonth() + 1, 0)
    })
    this.GetStatusCard();
  }

  GetStatusCard() {
    const self = this;

    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.GetStatusCard(localStorage.getItem('email'), localStorage.getItem('token'), response.payload.r01, response => {
        if (response.status.code === "0") {
          // requested disabled payment sent enabled blocked
          self.setState({
            statusCard:response.payload.card_status,
            card_cost:response.payload.card_cost
          });
        } else {
        }
      });
    });
  }


  renderContent(){
      switch(this.state.statusCard){
        case 'enabled':
          return (<CardView  traductions={this.props.traductions} data={this.props.data}/>)
          break;
        case 'payment':
          return (<Payment  traductions={this.props.traductions} GetStatusCard={this.GetStatusCard} data={this.props.data} card_cost={this.state.card_cost}/>)
          break;
        case 'assignation':
        case 'sent':
          return (<Confirm  traductions={this.props.traductions} GetStatusCard={this.GetStatusCard} data={this.props.data}/>)
          break;
        case 'disabled':
        case '-':
          return (<Solicitud  traductions={this.props.traductions} GetStatusCard = {this.GetStatusCard} data={this.props.data} card_cost={this.state.card_cost}/>)
          break;
        case '':
          break;
        default :
          return (<StatusView status={this.state.statusCard} data={this.props.data}/>)
          break
      }

  }

  render(){
    return(

        <div>
          <NavbarComponent data={this.props} selected="card" logged={true} />
          <RenovateTokenAlert data={this.props} />
          {
             this.renderContent()
          }
        </div>
    )
  }
}
